export default __webpack_public_path__ + "static/media/36I-117144_-37340_0.a4af3e06.jpg";